module.exports = __webpack_public_path__ + "static/media/check-box.165478bc.svg";